import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputProps } from "@mui/material";
import { AppDialog, AppDialogProps, InputPassword } from "@/components/common";
import { CommonUtils } from "@/utils";
import { PayloadChangePasswordType } from "@/services";
import { PasswordForm } from "../Profile.style";

type ChangePasswordDialogProps = AppDialogProps & {
  onChangePassword: (payload: PayloadChangePasswordType) => void;
};

const DEFAULT_PASSWORD_PAYLOAD: PayloadChangePasswordType = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};

const ChangePasswordDialog: FC<ChangePasswordDialogProps> = ({ open, onClose, onChangePassword }) => {
  const { t: getLabel } = useTranslation();

  const [payload, setPayload] = useState<PayloadChangePasswordType>(DEFAULT_PASSWORD_PAYLOAD);

  const handleClose = () => {
    setPayload(DEFAULT_PASSWORD_PAYLOAD);
    onClose();
  };

  const handleChangeTextField: InputProps["onChange"] = event => {
    setPayload(currentState => ({
      ...currentState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = () => {
    onChangePassword(payload);
  };

  useEffect(() => {
    setPayload(DEFAULT_PASSWORD_PAYLOAD);
  }, [open]);

  const isEnableButton =
    CommonUtils.checkPasswordFormat(payload.password) &&
    CommonUtils.checkPasswordFormat(payload.newPassword) &&
    CommonUtils.checkPasswordFormat(payload.confirmPassword) &&
    payload.newPassword === payload.confirmPassword;

  return (
    <AppDialog
      open={open}
      onClose={handleClose}
      title={getLabel("L_CHANGE_PASSWORD")}
      ConfirmButtonProps={{
        label: getLabel("L_UPDATE"),
        disabled: !isEnableButton,
        onClick: handleSubmit,
      }}
      CancelButtonProps={{
        sx: { display: "none" },
      }}
    >
      <PasswordForm>
        <InputPassword
          label={getLabel("L_CURRENT_PASSWORD")}
          value={payload.password}
          name="password"
          onChange={handleChangeTextField}
        />
        <InputPassword
          label={getLabel("L_NEW_PASSWORD")}
          value={payload.newPassword}
          name="newPassword"
          onChange={handleChangeTextField}
        />
        <InputPassword
          label={getLabel("L_RE_NEW_PASSWORD")}
          value={payload.confirmPassword}
          name="confirmPassword"
          onChange={handleChangeTextField}
        />
      </PasswordForm>
    </AppDialog>
  );
};

export default ChangePasswordDialog;
